import React from "react";
import * as globalReducer from "@/containers/App/reducer";
import { useDispatch } from "@/types/store";
import { useHistory } from "react-router-dom";
import styles from "@/components/View/style.module.css";
import { Button } from "@/aible";
import ChatCapabilityList from "@/components/ChatGPT/ChatCapabilityList";
import UseCaseLineage from "@/components/Lineage/UseCaseLineage";
import aibleIconSVG from "images/Aible_Badge-Full-Color.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen, faVideo, faXmark } from "@fortawesome/free-solid-svg-icons";
import { AgentCapabilitiesList } from "@/components/View/TemplatesView";
import ChatAppLineage from "@/components/Lineage/ChatAppLineage";
import { cn } from "@/utils/cn";
const getSparkDoctypeById = (id) => {
    if (id === "HEALTHCARE_FRAUD" || id === "RETAIL_WHATS_CHANGED_AND_WHY") {
        return "overview";
    }
    else if (id === "FINANCIAL_CONSUMER_COMPLAINTS_WHATS_CHANGED" || id === "RETAIL_SALES_DEEP_DIVE") {
        return "deep_dive";
    }
    else if (id === "CHATAIBLE_RAW_CHAT" || id === "EMPLOYEE_HANDBOOK") {
        return "document_summarization";
    }
};
const getAgentStepsType = (selectedItem) => {
    if (selectedItem?.wizard?.chatGPT?.chatType === "SQL") {
        if (selectedItem?.wizard?.chatGPT?.chatFlow === "REASONING") {
            return "REASONING_NLQ";
        }
        else {
            return "NLQ";
        }
    }
    else if (selectedItem?.wizard?.chatGPT?.chatType === "AIBLE") {
        if (selectedItem?.wizard?.chatGPT?.chatFlow === "REASONING") {
            return "REASONING_ANALYTICS";
        }
        else {
            return "ANALYTICS";
        }
    }
    else if (selectedItem?.wizard?.chatGPT?.chatType === "WHATS_CHANGED") {
        return "WHATS_CHANGED";
    }
    else if (selectedItem?.wizard?.chatGPT?.chatType === "DOCUMENT") {
        return "DOCUMENT";
    }
    return undefined;
};
const SparkRightPanel = ({ selectedItem, setSelectedItem, setDoctype, setVideoDoctype }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const agentStepsType = getAgentStepsType(selectedItem);
    const handleTryClick = () => {
        if (selectedItem.itemType === "Agent") {
            return history.push("templates/" + selectedItem?.id);
        }
        dispatch(globalReducer.updateIsSkipNextInit(undefined));
        dispatch(globalReducer.updateIsSkipChatGPTInit(undefined));
        dispatch(globalReducer.updateIsSkipChatGPTReset(undefined));
        return history.push("chatTemplate/" + selectedItem?.id);
    };
    if (!selectedItem)
        return null;
    const selectedDoctype = getSparkDoctypeById(selectedItem?.id);
    const videoDocuments = selectedDoctype && "video_" + selectedDoctype;
    const documents = selectedDoctype && "doc_" + selectedDoctype;
    return (React.createElement("div", { className: "absolute right-0 bottom-0 w-full max-w-xl z-1 h-[calc(100%-120px)] bg-white border-l border-gray-200 overflow-y-auto" },
        React.createElement("button", { className: "absolute right-3 top-3 z-10", onClick: () => setSelectedItem(undefined) },
            React.createElement(FontAwesomeIcon, { icon: faXmark, style: { color: "#868595" } })),
        React.createElement("div", { className: "flex items-center gap-2.5 p-5 border-b border-gray-200" },
            React.createElement("div", { className: "max-w-9" },
                React.createElement("img", { className: "block max-w-full w-fit", src: selectedItem.wizard.base64StringLogo || aibleIconSVG, alt: selectedItem.name })),
            React.createElement("div", { className: "text-lg bold" }, selectedItem?.name ?? "Missing item Name")),
        React.createElement("div", { className: "space-y-5 py-5" },
            React.createElement("div", { className: cn("flex items-center justify-end px-5", selectedDoctype ? "justify-between" : "justify-end") },
                selectedDoctype && (React.createElement("div", { className: "flex items-center gap-6" },
                    React.createElement("div", { className: "text-(--blueprint-text) space-x-1 flex items-center cursor-pointer hover:underline", onClick: () => setVideoDoctype(videoDocuments) },
                        React.createElement("div", null, "Video Overview"),
                        React.createElement(FontAwesomeIcon, { icon: faVideo })),
                    React.createElement("div", { className: "text-(--blueprint-text) space-x-1 flex items-center cursor-pointer hover:underline", onClick: () => setDoctype(documents) },
                        React.createElement("div", null, "Read Documentation"),
                        React.createElement(FontAwesomeIcon, { icon: faBookOpen })))),
                React.createElement(Button, { type: "primary", onClick: () => handleTryClick(), className: cn(!selectedDoctype && "w-full") }, "Use Template")),
            React.createElement("div", { className: "px-5" }, selectedItem?.wizard?.description || selectedItem.description),
            (selectedItem?.itemType === "Agent" || selectedItem?.agentStepsType) && (React.createElement("div", { className: "px-5" },
                React.createElement("div", { className: "text-[#868595]" }, "Capabilities"),
                React.createElement("div", { className: styles.itemCapabilitiesList },
                    selectedItem?.itemType === "Agent" && (React.createElement(AgentCapabilitiesList, { type: selectedItem?.media, useGuardrails: selectedItem?.isGuardrailsEnabled })),
                    selectedItem?.agentStepsType && (React.createElement(ChatCapabilityList, { agentStepTypeOverride: agentStepsType, listOnly: true }))))),
            (selectedItem?.itemType === "ChatApp" || selectedItem?.itemType === "ChatUseCase") && (React.createElement("div", { className: "px-5" },
                selectedItem?.itemType === "ChatApp" && React.createElement(ChatAppLineage, { id: selectedItem?.id }),
                selectedItem?.itemType === "ChatUseCase" && React.createElement(UseCaseLineage, { id: selectedItem?.id }))))));
};
export default SparkRightPanel;
